import MuiSkeleton, { SkeletonProps } from '@mui/material/Skeleton';
import { styled } from '@mui/material/styles';

export const Skeleton = styled(MuiSkeleton)<SkeletonProps>(({ theme }) => ({
  background: 'linear-gradient(270deg, #DFE3E8 0%, #F9FAFB 100%)',
  borderRadius: 0,
}));
